import { combineReducers } from "redux";
import time from "./reducers/timerReducer";
import userInfo from "./reducers/userInfoReducer";
import userState from "./reducers/userStateReducer";
import modalState from "./reducers/modalStateReducer";
import division from "./reducers/divisionReducer";
import todo from "./reducers/todoReducer";
import timeTable from "./reducers/timeTableReducer";
import {
  mailListReducer,
  mailToListReducer,
  mailTempListReducer,
  addressListReducer,
} from "./reducers/mailReducer";
import memoList from "./reducers/memoReducer";
import reportList from "./reducers/reportReducer";
import messenger from "./reducers/messengerReducer";
import attachFile from "./reducers/attachFileListReducer";
import alertMessage from "./reducers/alertMessageReducer";
import uprismState, { chat } from "./reducers/uprismStateReducer";
import device from "./reducers/mediaStreamReducer";
import socket from "./reducers/socketReducer";
import { persistReducer } from "redux-persist";
import createWebStorage from "redux-persist/lib/storage/createWebStorage";

const createNoopStorage = () => {
  return {
    getItem(_key) {
      return Promise.resolve(null);
    },
    setItem(_key, value) {
      return Promise.resolve(value);
    },
    removeItem(_key) {
      return Promise.resolve();
    },
  };
};

const storage =
  typeof window === "undefined"
    ? createNoopStorage()
    : createWebStorage("local");

const persistConfig = {
  key: "root",
  storage: storage,
  whitelist: ["device", "socket", "userInfo", "timeTable", "time"],
};

const reducers = combineReducers({
  time,
  userInfo,
  userState,
  modalState,
  division,
  timeTable,
  todo,
  mailList: mailListReducer,
  mailToList: mailToListReducer,
  mailTempList: mailTempListReducer,
  addressList: addressListReducer,
  memoList,
  reportList,
  messenger,
  attachFile,
  alertMessage,
  uprismState,
  chat,
  device,
  socket,
});

export default persistReducer(persistConfig, reducers);
